import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getAllModules } from '../../redux/actions/company';
import {
  registerEmployeeRole,
  getSingleEmployeeRole,
  updateEmployeeRole,
} from '../../redux/actions/employee';

import EmployeeRoleRegister from './EmployeeRoleRegister.page';

const mapStateToProps = state => ({
  allModules: state.organization.allModules,
  detailRoleEmployee: state.organization.detailRoleEmployee,
  getLoading: state.organization.getLoading,
});

const mapDispatchToProps = {
  getSingleEmployeeRole,
  getAllModules,
  registerEmployeeRole,
  updateEmployeeRole,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeRoleRegister));
